@if (sessionToShow) {
    <div class="w-full h-auto bg-white md:rounded-2xl p-4 pt-2 md:shadow-fm font-inter">
        <!-- <div
        class="flex flex-col items-center justify-start gap-[4px] p-[12px] w-full bg-white rounded-xl"> -->
        <div class="w-full flex flex-row justify-start items-center">
            <div class="text-bluegrey-2 font-medium text-14 leading-[normal]">
                @if (!isSessionOngoing) {
                    Upcoming
                } @else {
                    Ongoing
                }
            </div>
        </div>

        @if (!sessionToShow) {
            <div class="flex flex-col justify-center items-center w-full">
                <div
                    class="text-bluegrey-2 font-avenir font-medium text-[12px] p-[8px] leading-normal w-full text-center rounded-lg bg-blurple-4">
                    No upcoming sessions
                </div>
            </div>
        } @else {
            <div class="w-full flex flex-col justify-start items-center">
                <div class="flex flex-col justify-center items-center w-full">
                    @if (showTimer) {
                        <app-fm-timer
                            class="w-full text-[#F97316] font-meidum text-left text-12 leading-[normal] mb-2 mt-4"
                            [sessionTime]="sessionToShow.sessionTime"
                            [sessionType]="sessionToShow.sessionType"
                            [sessionDuration]="sessionToShow.duration"
                            [isInSessionTimer]="false"
                            [isValidSession]="true"
                            [isTestSession]="false" />
                    } @else {
                        <div
                            class="w-full font-meidum text-left text-12 leading-[normal] text-bluegrey-2 mb-2 mt-4">
                            {{
                                this.sessionToShow.sessionTime
                                    | epochToTime: 'dddd, MMMM D' : this.timeZone
                            }}
                        </div>
                    }

                    <fm-booked-session-tile
                        class="w-full"
                        height="92"
                        [sessionInfo]="sessionToShow"
                        [timezone]="timeZone" />
                </div>
            </div>
        }
    </div>
}
